import axios from 'axios';
import { getApiBaseUrl } from './apiBase';

const API_URL = `${getApiBaseUrl()}/bundles`;

export const bundleService = {
  list: async (token) => {
    const res = await axios.get(API_URL, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    return res.data;
  },
  create: async (payload, token) => {
    const res = await axios.post(API_URL, payload, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
  },
  update: async (id, payload, token) => {
    const res = await axios.put(`${API_URL}/${id}`, payload, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
  },
  setActive: async (id, isActive, token) => {
    const res = await axios.put(`${API_URL}/${id}/deactivate`, { isActive }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
  },
  assign: async (payload, token) => {
    const res = await axios.post(`${API_URL}/assign`, payload, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
  },
  assignmentsForUser: async (userId, token) => {
    const res = await axios.get(`${API_URL}/assignments/${userId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
  },
  usageForUser: async (userId, token) => {
    const res = await axios.get(`${API_URL}/usage/${userId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
  },
  mine: async (token) => {
    const res = await axios.get(`${API_URL}/mine`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
  },
  available: async (token) => {
    const res = await axios.get(`${API_URL}/available`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
  },
  purchase: async (id, token) => {
    const res = await axios.post(`${API_URL}/purchase/${id}`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
  }
};
